<template>
  <q-page
    class="static q-mb-xl"
    dir="ltr"
  >
    <section class="container q-px-md no-rtl">
      <div class="row justify-center">
        <div class="col-md-8">
          <h1 class="text-black break-word">{{ $t('pages.privacy_policy.header') }}</h1>

          <div
            v-for="item in $t('pages.privacy_policy.subitems')"
            :key="item.header"
          >
            <h3
              :id="item.ancor"
              class="text-black break-word"
            >
              {{ item.header }}
            </h3>
            <template v-for="subitem in item.items">
              <div
                v-if="showRakuten || !subitem.includes('rakuten_policy')"
                :key="subitem"
                class="terms-item q-my-md text-justify"
                v-html="subitem"
              />
            </template>
          </div>
        </div>
      </div>
    </section>
  </q-page>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'PrivacyPolicy',
  computed: {
    ...mapGetters(['configs']),
    showRakuten() {
      return this.configs.render_cpa_scripts === 'rakuten';
    },
  },
};
</script>
